<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="middle-panel" @click.stop>
                <div class="dialog-title" v-t="'message.item_two_phase_method_setting'">
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body-small">
                    <el-form label-width="320px" class="dialog-form-item">
                        <!-- ##################################### -->
                        <!-- Two Phase Method ON/OFF               -->
                        <!-- ##################################### -->
                        <el-form-item prop="methodType" ref="methodType">
                            <div slot="label" style="text-align:left" >
                                <span v-t="'message.item_two_phase_method_app'"/>
                            </div>
                            <el-switch v-model="twoPhaseMethod" active-color="#5171cb">
                            </el-switch>
                        </el-form-item>
                        <el-form-item prop="methodType" ref="methodType">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_two_phase_method_console'"/>
                            </div>
                            <el-switch v-model="twoPhaseMethodConsole" active-color="#5171cb">
                            </el-switch>
                        </el-form-item>
                    </el-form>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="buttonConfig.disabled" @click="buttonConfig.clickHandler" v-t="'message.button_save'"></el-button>
                </div>
            </div>
            <el-dialog :visible.sync="showWarningDialogTurnOff" width="30%" append-to-body>
                <div v-t="'message.warn_reset_two_phase_auth1'"></div>
                <div v-t="'message.warn_reset_two_phase_auth2'" style="color: red;"></div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleWarningDialogClose" v-t="'message.button_cancel'"></el-button>
                    <el-button type="primary" @click="handleWarningDialogOk" v-t="'message.button_ok'"></el-button>
                </span>
            </el-dialog>
        </div>
    </transition>
</template>

<script>

export default {
    data() {
        return {
            twoPhaseMethod: false,
            twoPhaseMethodConsole: false,
            showWarningDialogTurnOff: false,
            emitName: ''
        };
    },
    methods: {
        saveChangeApp: function() {
            this.$emit('saveApp', {twoPhaseMethod: this.twoPhaseMethod});
        },
        saveChangeConsole: function() {
            this.$emit('saveConsole', {twoPhaseMethodConsole: this.twoPhaseMethodConsole});
        },
        saveChangeBoth: function() {
            this.$emit('saveBoth', {
                twoPhaseMethod: this.twoPhaseMethod,
                twoPhaseMethodConsole: this.twoPhaseMethodConsole
            });
        },
        displayWarningDialog() {
            if (this.twoPhaseMethodConsole) {
                if (this.emitName == 'saveConsole') {
                    this.saveChangeConsole();
                } else if (this.emitName == 'saveBoth') {
                    this.saveChangeBoth();
                }
                return;
            }
            this.showWarningDialogTurnOff = true;
        },
        handleWarningDialogOk() {
            if (this.emitName == 'saveConsole') {
                this.saveChangeConsole();
            } else if (this.emitName == 'saveBoth') {
                this.saveChangeBoth();
            }
            this.showWarningDialogTurnOff = false;
        },
        handleWarningDialogClose() {
            this.showWarningDialogTurnOff = false;
        },
    },
    created: function() {
        this.twoPhaseMethod = this.appData.twoPhaseMethod;
        this.twoPhaseMethodConsole = this.appData.twoPhaseMethodConsole;
    },
    computed: {
        buttonConfig() {
            let config = {
                disabled: true,
                clickHandler: () => {},
            };

            if (this.twoPhaseMethod === this.appData.twoPhaseMethod && this.twoPhaseMethodConsole === this.appData.twoPhaseMethodConsole) {
                config.disabled = true;
            } else if (this.twoPhaseMethod !== this.appData.twoPhaseMethod && this.twoPhaseMethodConsole === this.appData.twoPhaseMethodConsole) {
                config.disabled = false;
                this.emitName = 'saveApp';
                config.clickHandler = this.saveChangeApp;
            } else if (this.twoPhaseMethod === this.appData.twoPhaseMethod && this.twoPhaseMethodConsole !== this.appData.twoPhaseMethodConsole) {
                config.disabled = false;
                this.emitName = 'saveConsole';
                config.clickHandler = this.displayWarningDialog;
            } else if (this.twoPhaseMethod !== this.appData.twoPhaseMethod && this.twoPhaseMethodConsole !== this.appData.twoPhaseMethodConsole) {
                config.disabled = false;
                this.emitName = 'saveBoth';
                config.clickHandler = this.displayWarningDialog;
            }

            return config;
        }
    },
    props: ['appData' ]
}
</script scoped>

<style scoped>
button.input-pass-check {
    border-style: none;
    background-color: #fff;
    cursor: pointer;
    outline: none;
    position: absolute;
    height: 20px;
    width: 44px;
    left: 305px;
    top: 2px;
    z-index: 10;
    color: #848991;
    font-size: 10px;
}
.el-select.select-two-phase-method-item {
    width: 350px;
}
.middle-panel {
    background: #fff;
    position: absolute;
    padding: 0;
    left: 50%;
    top: 50%;
    width: 580px;
    max-height: 80vh;
    margin-top: -40vh;
    margin-left: -250px;
    transition: all .3s ease;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
}

</style>
